import React from 'react'
import { Box } from '@node-space/ui-components'

interface DetailsRowProps {
  label: string
  children: React.ReactNode
}

export const DetailsRow = ({ label, children }: DetailsRowProps) => {
  return (
    <Box flexCol gapY={4}>
      <Box tag="span" className="text-gray-08 text-sm">
        {label}
      </Box>
      <Box className="text-gray-900 text-sm font-medium">{children}</Box>
    </Box>
  )
}
